import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, AutoComplete, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../AdvanceCreditorSlice";
import { fetchAdvanceCreditors } from "../AdvanceCreditorSlice";
import { getAccountBySeachApi, getLocationApi } from "../../../../apiservice/setting";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { searchSuppliers } from "../../SupplierLedger/supplierLedgerThunk";

const AdvanceCreditorFilters = ({ messageApi }) => {
    const dispatch = useDispatch();
    const { filters } = useSelector((state) => state.advanceCreditor);
    const [accounts, setAccounts] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loadingAccounts, setLoadingAccounts] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const { searchResults, loadingSearch } = useSelector((state) => state.supplierLedger);

    const filterTypes = [
        { value: "All Creditor", label: "All Creditor" },
        { value: "Creditor Wise", label: "Creditor Wise" },
        { value: "Location Wise", label: "Location Wise" },
    ];

    const handleSearchSuppliers = useCallback(
        (text) => {
            dispatch(searchSuppliers(text));
        },
        [dispatch]
    );

    useEffect(() => {
        // Fetch locations on component mount
        getLocationApi(null).then((res) => {
            if (res.data) {
                setLocations(res.data);
            }
        });
    }, []);

    useEffect(() => {
        // Debounced account search
        if (searchTerm.trim() && filters.filterType === "Creditor Wise") {
            setLoadingAccounts(true);
            const timer = setTimeout(() => {
                getAccountBySeachApi({
                    query: searchTerm.trim(),
                    type: "creditor",
                })
                    .then((res) => {
                        setAccounts(res.data || []);
                        setLoadingAccounts(false);
                    })
                    .catch(() => {
                        setLoadingAccounts(false);
                    });
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [searchTerm, filters.filterType]);

    const handleFilterChange = (field, value) => {
        dispatch(setFilters({ [field]: value }));

        // Clear dependent fields when filter type changes
        if (field === "filterType") {
            dispatch(setFilters({ creditorId: null, locationId: null }));
            setSearchTerm("");
            setAccounts([]);
        }
    };

    const handleReport = () => {
        if (!filters.filterType) {
            messageApi.warning("Select Filter Type");
            return;
        }

        dispatch(fetchAdvanceCreditors({ filters })).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                messageApi.success("Report loaded ✅");
            } else {
                messageApi.error("Failed to fetch records ❌");
            }
        });
    };

    const renderExtraField = () => {
        switch (filters.filterType) {
            case "Creditor Wise":
                return (
                    <Col span={6}>
                        <label>Search Creditor</label>
                        {/* <AutoComplete
              options={accounts.map(acc => ({
                value: acc.acc_id,
                label: acc.acc_name,
                ...acc
              }))}
              value={filters.creditorName}
              onSelect={(value, option) => {
                handleFilterChange("creditorId", option.value);
                handleFilterChange("creditorName", option.label);
              }}
              onSearch={(value) => setSearchTerm(value)}
              placeholder="Search Creditor"
              notFoundContent={loadingAccounts ? "Searching..." : "No creditors found"}
            >
              <Input.Search 
                loading={loadingAccounts}
                placeholder="Search Creditor" 
              />
            </AutoComplete> */}
                        <SearchListAutoComplete
                            entityType="supplier"
                            searchThunk={handleSearchSuppliers}
                            resultSelector={(state) => state.supplierLedger.searchResults}
                            loading={loadingSearch}
                            onSelect={(obj) => {
                                if (!obj) {
                                // cleared
                                handleFilterChange("creditorId", null);
                                handleFilterChange("creditorName", "");
                                return;
                                }
                                handleFilterChange("creditorId", obj.acc_id);
                                handleFilterChange("creditorName", obj.acc_name);
                            }}
                            placeholder="Supplier"
                            
                        />
                    </Col>
                );

            case "Location Wise":
                return (
                    <Col span={6}>
                        <label>Select Location</label>
                        <AutoComplete
                            options={locations.map(loc => ({
                                value: loc.location_id,
                                label: loc.location_name,
                                ...loc
                            }))}
                            value={filters.locationName}
                            onSelect={(value, option) => {
                                handleFilterChange("locationId", option.value);
                                handleFilterChange("locationName", option.label);
                            }}
                            placeholder="Select Location"
                        >
                            <Input placeholder="Select Location" />
                        </AutoComplete>
                    </Col>
                );

            default:
                return null;
        }
    };

    return (
        <Card className="mb-4 shadow-md rounded-xl">
            <Row gutter={16} style={{ alignItems: "center" }}>
                <Col span={6}>
                    <label>Filter Type</label>
                    <AutoComplete
                        options={filterTypes}
                        value={filters.filterType}
                        onSelect={(value) => handleFilterChange("filterType", value)}
                        placeholder="Filter Type"
                    >
                        <Input placeholder="Filter Type" />
                    </AutoComplete>
                </Col>

                {renderExtraField()}

                <Col span={4} style={{ display: "flex", alignItems: "center", height: 58 }}>
                    <Button type="primary" icon={<SearchOutlined />} data-testid="report-btn" onClick={handleReport} style={{height: 35.19}} block>
                        Report
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

export default AdvanceCreditorFilters;